import type { ModalProps } from '@workramp/ui';
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Option,
  Row,
  Select,
  Stack,
  TextField,
} from '@workramp/ui';
import { useState } from 'react';
import StringUtils from '~/common/string-utils';
import { I18n } from '~/common/explicit-exports';

export interface WebhookTestModalProps extends Omit<ModalProps, 'children'> {
  isOpen: boolean;
  onTestWebhook: (eventType) => void;
  webhookEventTypeOptions: string[];
  webhookSubscriptionUrl: string;
}

export const WebhookTestModal = ({
  webhookEventTypeOptions,
  onTestWebhook,
  webhookSubscriptionUrl,
  onClose,
  ...props
}: WebhookTestModalProps) => {
  const TEST_WEBHOOK_MODAL_HEADING = I18n.t(
    'js.admin.integration_settings.webhook_subscriptions.test_webhook_modal.heading',
  );
  const TEST_WEBHOOK_MODAL_DESCRIPTION = I18n.t(
    'js.admin.integration_settings.webhook_subscriptions.test_webhook_modal.description',
  );

  const TEST_WEBHOOK_MODAL_SEND = I18n.t('js.admin.integration_settings.webhook_subscriptions.test_webhook_modal.send');
  const CANCEL = I18n.t('js.common.modal.cancel');

  const [event, setEvent] = useState<string | number>('');

  const handleExit = () => {
    setEvent('');
  };

  return (
    <Modal {...props} onExit={handleExit} onClose={onClose}>
      <ModalHeader title={TEST_WEBHOOK_MODAL_HEADING} description={TEST_WEBHOOK_MODAL_DESCRIPTION} />
      <ModalBody>
        <Stack size={4}>
          <TextField label="URL" value={webhookSubscriptionUrl} isReadOnly isDisabled />
          <Select label="Event" title="Event" onSelectionChange={setEvent} selectedKey={event}>
            {webhookEventTypeOptions.map((type) => (
              <Option key={type}>{StringUtils.getCapitalizedWordsFromCamelCasedString(type.replace('.', ': '))}</Option>
            ))}
          </Select>
        </Stack>
      </ModalBody>
      <ModalFooter
        actions={
          <Row gapX={2}>
            <Col xs="auto">
              <Button variant="text" color="secondary" onPress={onClose}>
                {CANCEL}
              </Button>
            </Col>
            <Col xs="auto">
              <Button
                onPress={() => {
                  onTestWebhook(event);
                }}
                isDisabled={!event}
              >
                {TEST_WEBHOOK_MODAL_SEND}
              </Button>
            </Col>
          </Row>
        }
      />
    </Modal>
  );
};
